import { render, staticRenderFns } from "./sku-info.vue?vue&type=template&id=68f233b1&"
import script from "./sku-info.vue?vue&type=script&lang=js&"
export * from "./sku-info.vue?vue&type=script&lang=js&"
import style0 from "./sku-info.vue?vue&type=style&index=0&id=68f233b1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports